module.exports = __webpack_public_path__ + "media/images/diy/testimonial_charlotte-8bf67c6267cc26fbab4511a823e3de4e.jpg";